'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var React = require('react');
var React__default = _interopDefault(React);
var core = require('@material-ui/core');
var MediumEmphasizedDarkText = require('../../../typography/MediumEmphasizedDarkText/MediumEmphasizedDarkText.js');
var styledComponents = require('../styled-components.js');
var utils = require('../utils.js');
var VerticalTitleAndLink = require('../../../VerticalTitleAndLink/VerticalTitleAndLink.js');
var styledComponents$1 = require('./styled-components.js');

var VerticalAvatar = function (props) {
    var name = props.name, avatarSrc = props.avatarSrc, linkText = props.linkText, url = props.url, linkComponent = props.linkComponent, _a = props.className, className = _a === void 0 ? '' : _a;
    var classes = styledComponents.useStyles();
    var avatar = utils.getAvatar(avatarSrc, name, classes);
    return (React__default.createElement(styledComponents$1.StyleGridContainer, { container: true, direction: 'column', alignItems: 'center', className: className },
        React__default.createElement(core.Grid, { item: true },
            React__default.createElement(styledComponents$1.AvatarContainer, null, avatar)),
        React__default.createElement(core.Grid, { item: true }, linkComponent ? (React__default.createElement("div", { style: { display: 'flex', flexDirection: 'column' } },
            React__default.createElement(MediumEmphasizedDarkText, null, name),
            linkComponent)) : (React__default.createElement(VerticalTitleAndLink, { "data-testid": 'title-and-link', titleText: name, url: url, linkText: linkText })))));
};

module.exports = VerticalAvatar;
